<ng-container *transloco="let t">
  <mat-card class="p-0">
    <div class="flexBoxOuter rowBackgroundRed">
      <div class="center-box flexBoxInnerWrapper color-white">
        <div class="centeredBoxText">
          <h3>{{ t("register.catch.curious") }}</h3>
        </div>
        <div class="centeredBoxText">{{ t("register.catch.ki") }}</div>
        <div class="centeredBoxText mt-4">
          {{ t("register.catch.test-ki") }}
        </div>
      </div>
    </div>
  </mat-card>

  <!-- register form section -->
  <div class="centeredBox flexBoxOuter rowBackgroundBlue reg-container">
    <div class="flexBoxInnerWrapper mt-6">
      <div class="centeredBoxText" style="padding-bottom: 20px">
        <h4>{{ t("register.form.first-account.title-1") }}</h4>
        <div>
          <p>{{ t("register.form.first-account.text-1") }}</p>
        </div>
      </div>
      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.account.email$ | async) ?? ''"
        (referenceChange)="registrationModel.account.email = $event"
        [translateDescriptionBaseKey]="'global.form.email'"
        [descriptionBaseKey]="'global.form.email'"
        #emailValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.account.formValidator.watchKey$('email') | async"
        (click)="emailValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />
      <app-text-input
        [type]="'password'"
        [rowId]="1"
        [reference]="(registrationModel.account.password$ | async) ?? ''"
        (referenceChange)="registrationModel.account.password = $event"
        [translateDescriptionBaseKey]="'global.form.newpassword'"
        [descriptionBaseKey]="'global.form.newpassword'"
        #passwordValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.account.formValidator.watchKey$('password') | async"
        (click)="passwordValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />
      <password-strength-meter
        [password]="(registrationModel.account.password$ | async) ?? ''"
        style="display: flex; margin-bottom: 10px; margin-top: 5px; margin-left: 197px"
      ></password-strength-meter>
      <app-text-input
        [type]="'password'"
        [rowId]="1"
        [reference]="(registrationModel.account.confirmPassword$ | async) ?? ''"
        (referenceChange)="registrationModel.account.confirmPassword = $event"
        [translateDescriptionBaseKey]="'global.form.confirmpassword'"
        [descriptionBaseKey]="'global.form.confirmpassword'"
        #confirmPasswordValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.account.formValidator.watchKey$('confirmPassword') | async"
        (click)="confirmPasswordValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.account.firstName$ | async) ?? ''"
        (referenceChange)="registrationModel.account.firstName = $event"
        [translateDescriptionBaseKey]="'settings.form.firstname'"
        [descriptionBaseKey]="'settings.form.firstname'"
        #firstNameValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.account.formValidator.watchKey$('firstName') | async"
        (click)="firstNameValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.account.lastName$ | async) ?? ''"
        (referenceChange)="registrationModel.account.lastName = $event"
        [translateDescriptionBaseKey]="'settings.form.lastname'"
        [descriptionBaseKey]="'settings.form.lastname'"
        #lastNameValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.account.formValidator.watchKey$('lastName') | async"
        (click)="lastNameValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <div class="centeredBoxText mt-6 mb-3">
        <h4>{{ t("register.form.company.title") }}</h4>
        <div>
          <p>{{ t("register.form.company.text-1") }}</p>
        </div>
        <div>
          <p>{{ t("register.form.company.text-2") }}</p>
        </div>
      </div>

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.organisation.name$ | async) ?? ''"
        (referenceChange)="registrationModel.organisation.name = $event"
        [translateDescriptionBaseKey]="'settings.form.orgname'"
        [descriptionBaseKey]="'settings.form.orgname'"
        #organisationNameValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.formValidator.watchKey$('name') | async"
        (click)="organisationNameValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.organisation.street$ | async) ?? ''"
        (referenceChange)="registrationModel.organisation.street = $event"
        [translateDescriptionBaseKey]="'settings.form.orgStreet'"
        [descriptionBaseKey]="'settings.form.orgStreet'"
        #organisationStreetValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.addressFormValidator.watchKey$('street') | async"
        (click)="organisationStreetValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.organisation.zipCode$ | async) ?? ''"
        (referenceChange)="registrationModel.organisation.zipCode = $event"
        [translateDescriptionBaseKey]="'settings.form.orgZipcode'"
        [descriptionBaseKey]="'settings.form.orgZipcode'"
        #organisationZipcodeValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.addressFormValidator.watchKey$('zipCode') | async"
        (click)="organisationZipcodeValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.organisation.place$ | async) ?? ''"
        (referenceChange)="registrationModel.organisation.place = $event"
        [translateDescriptionBaseKey]="'settings.form.orgPlace'"
        [descriptionBaseKey]="'settings.form.orgPlace'"
        #organisationPlaceValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.addressFormValidator.watchKey$('place') | async"
        (click)="organisationPlaceValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-dynamic-single-selecter
        [reference]="registrationModel.organisation.country$ | async"
        (referenceChange)="registrationModel.organisation.country = $event ?? undefined"
        [translateDescriptionBaseKey]="'settings.form.orgCountry'"
        [descriptionBaseKey]="'settings.form.orgCountry'"
        [selectable]="['switzerland']"
        #countryValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.formValidator.watchKey$('country') | async"
        (click)="countryValidationMessage.hide()"
        [rowId]="1"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [rowId]="1"
        [reference]="(registrationModel.organisation.phone$ | async) ?? ''"
        (referenceChange)="registrationModel.organisation.phone = $event"
        [translateDescriptionBaseKey]="'settings.form.orgPhone'"
        [descriptionBaseKey]="'settings.form.orgPhone'"
        #phoneValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.formValidator.watchKey$('phone') | async"
        (click)="phoneValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <app-text-input
        [type]="'number'"
        [rowId]="1"
        [reference]="(registrationModel.organisation.numEmployees$ | async)?.toString() ?? ''"
        (referenceChange)="registrationModel.organisation.numEmployees = parseReferenceToNumber($event)"
        [translateDescriptionBaseKey]="'settings.form.orgNumEmployees'"
        [descriptionBaseKey]="'settings.form.orgNumEmployees'"
        #numEmployeesValidationMessage="appValidationMessage"
        [appValidationMessage]="registrationModel.organisation.formValidator.watchKey$('numEmployees') | async"
        (click)="numEmployeesValidationMessage.hide()"
        [mandatory]="true"
        [disabled]="formDisabled()"
      />

      <div class="kv-checkbox-wrapper">
        <span class="kw-label"
          ><strong>{{ t("settings.form.orgSiaMember") }}</strong></span
        >
        <mat-checkbox
          class="kv-checkbox"
          [checked]="registrationModel.organisation.siaIndividualMember$ | async"
          (change)="changeSiaStatus('individual', $event.checked)"
          [disabled]="formDisabled()"
          >{{ t("register.form.sia.single-membership") }}</mat-checkbox
        >
        <mat-checkbox
          class="kv-checkbox"
          [checked]="registrationModel.organisation.siaCorporateMember$ | async"
          (change)="changeSiaStatus('corporate', $event.checked)"
          [disabled]="formDisabled()"
          >{{ t("register.form.sia.company-membership") }}</mat-checkbox
        >
        @if (registrationModel.organisation.siaIndividualMember$ | async) {
          <div>
            <p class="help-block">
              {{ t("settings.messages.validate.orgSiaIndividualMember.tip") }}
            </p>
          </div>
        }
        @if (registrationModel.organisation.siaCorporateMember$ | async) {
          <div>
            <p class="help-block">{{ t("settings.messages.validate.orgSiaCorporateMember.tip") }}</p>
          </div>
        }
      </div>

      <app-text-input
        [rowId]="1"
        [type]="'number'"
        [reference]="(registrationModel.numAdditionalUsers$ | async)?.toString() ?? ''"
        (referenceChange)="registrationModel.numAdditionalUsers = parseReferenceToNumber($event)"
        [translateDescriptionBaseKey]="'settings.form.additionalAccounts'"
        [descriptionBaseKey]="'settings.form.additionalAccounts'"
        [mandatory]="false"
        [disabled]="formDisabled()"
      />

      <div class="kv-help-wrapper">
        <p class="help-block">
          <span>{{ t("settings.form.additionalAccounts.description") }}</span>
        </p>
      </div>
      <div class="kv-checkbox-wrapper">
        <mat-checkbox
          class="kv-checkbox"
          (change)="registrationModel.billingAddressSameAsOrganisation = $event.checked"
          [disabled]="formDisabled()"
          >{{ t("register.form.invoice-address") }}</mat-checkbox
        >
      </div>

      <!-- Billing Information Form start -->
      @if (!((registrationModel.billingAddressSameAsOrganisation$ | async) ?? true)) {
        <app-billing-information-form
          [billingContact]="registrationModel.organisation.billingContact"
          [disabled]="formDisabled()"
        ></app-billing-information-form>
      }

      <div class="kv-checkbox-wrapper">
        <mat-checkbox
          class="kv-checkbox"
          (change)="hasAcceptedConditions.set($event.checked)"
          [disabled]="formDisabled()"
        >
          {{ t("register.form.AGB.text-1-0") }}
          <span
            ><a href="../../pdf/{{ '' | currentLanguage }}/AGB_keeValue_AG.pdf" target="_blank">{{
              t("register.form.AGB.text-1-1")
            }}</a>
            {{ t("register.form.AGB.text-1-2") }}</span
          >
        </mat-checkbox>
      </div>
      <div class="kv-checkbox-wrapper">
        <mat-checkbox
          class="kv-checkbox reg-checkbox"
          (change)="hasAcceptedNoAnonymous.set($event.checked)"
          [disabled]="formDisabled()"
        >
          <span>{{ t("register.form.ANONYMOUS") }}</span>
        </mat-checkbox>
      </div>
      <div class="centeredBoxText mb-30">
        <button
          mat-button
          class="btn-elegant-black"
          color="primary"
          (click)="checkRegistration()"
          [disabled]="formDisabled()"
        >
          {{ t("register.form.button.title") }}
        </button>
      </div>

      @if (submitted()) {
        <div>
          @if (numEmp() <= maxEmployeesForSelfService && checkSuccess()) {
            <div class="alert kv-attention mt-3" [innerHtml]="t('register.messages.checkSuccess')"></div>
          }
          @if (numEmp() > maxEmployeesForSelfService && checkSuccess()) {
            <div class="alert kv-attention mt-3" [innerHtml]="t('register.messages.checkSuccess2')"></div>
          }
          @if (!hasAcceptedConditions()) {
            <div class="alert kv-attention" [innerHtml]="t('register.messages.error.acceptconditions')"></div>
          }
          @if (!hasAcceptedNoAnonymous()) {
            <div class="alert kv-attention" [innerHtml]="t('register.messages.error.accept-no-anonymous')"></div>
          }
          @if (hasError()) {
            <div class="alert kv-attention" [innerHtml]="t(hasError() ?? 'error.unknown-error')"></div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Custom License Part -->
  @if (hasStartFreeMonth() && checkSuccess() && numEmp() <= maxEmployeesForSelfService) {
    <div>
      <div class="centeredBoxText rowBackgroundWhite spacing" data-offset="66">
        <h4>{{ t("register.form.module.title") }}</h4>
        <p>{{ t("register.form.module.text-1") }}</p>
        <div class="flexBoxOuter transparent mt-4">
          <div class="flexBoxInner center-align">
            <div>
              @for (module of billingModules; track module.type) {
                <div class="check-wrapper">
                  <mat-checkbox
                    [value]="module.type"
                    [checked]="isModuleChecked(module.type)"
                    [disabled]="isModuleDisabled(module)"
                    (change)="onBillingModuleChange($event, module.type)"
                  >
                    {{ t(module.label) }}
                  </mat-checkbox>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="mt-4">
          <p>{{ t("register.form.module.info") }}</p>
        </div>
      </div>
    </div>
  }

  @if (showPriceTable()) {
    <div>
      <div class="centeredBox flexBoxOuter rowBackgroundWhite spacing">
        <div class="centeredBoxText">
          <h3>{{ t("register.form.license.title-1") }}</h3>
        </div>

        <div class="flexBoxOuter">
          <div class="flexBoxInner">
            {{ t("register.form.license.text-1-0") }}
            <span [innerHtml]="t('register.form.license.text-1-1')"></span>
          </div>
        </div>

        <!-- Subform specific license -->
        @if (billingResponse()) {
          <div [ngStyle]="{ opacity: isLoading() ? '0.2' : '1' }" class="centeredBox flexBoxOuter rowBackgroundWhite">
            <div class="centeredBoxText">
              <h4>{{ t("register.form.license.title-2") }}</h4>
              <div class="flexBoxOuter">
                <div class="license-table-box mt-10">
                  <table id="priceTable" class="table flexBoxInner">
                    <tbody>
                      <tr class="solidBottomBorder">
                        <td class="text-align">{{ t("prices.price.yearly") }}</td>
                        <td class="text-align">
                          {{ billingResponse().yearlyPriceBaseLicense / 100 | number: "1.2-2" }} CHF
                        </td>
                      </tr>
                      @if (billingResponse().yearlyModule2Discount > 0) {
                        <tr>
                          <td class="text-align">{{ t("prices.discount.module-2") }}</td>
                          <td class="text-align">
                            - {{ billingResponse().yearlyModule2Discount / 100 | number: "1.2-2" }} CHF
                          </td>
                        </tr>
                      }
                      @if (billingResponse().yearlyModule3Discount > 0) {
                        <tr>
                          <td class="text-align">{{ t("prices.discount.module-3") }}</td>
                          <td class="text-align">
                            - {{ billingResponse().yearlyModule3Discount / 100 | number: "1.2-2" }} CHF
                          </td>
                        </tr>
                      }
                      @if (
                        billingResponse().yearlyModule4Discount !== null && billingResponse().yearlyModule4Discount > 0
                      ) {
                        <tr>
                          <td class="text-align">{{ t("prices.discount.module-4") }}</td>
                          <td>
                            <div class="text-align">
                              - {{ billingResponse().yearlyModule4Discount / 100 | number: "1.2-2" }} CHF
                            </div>
                          </td>
                        </tr>
                      }
                      @if (registrationModel.organisation.siaIndividualMember$ | async) {
                        <ng-container>
                          <tr>
                            <td class="text-align">
                              {{ billingResponse().discountInPercentSiaIndividual | number: "1.0-0"
                              }}{{ t("prices.discount.sia-single") }}
                            </td>
                            <td class="text-align">
                              - {{ billingResponse().yearlySiaDiscount / 100 | number: "1.2-2" }} CHF
                            </td>
                          </tr>
                        </ng-container>
                      }
                      @if (registrationModel.organisation.siaCorporateMember$ | async) {
                        <ng-container>
                          <tr>
                            <td class="text-align">
                              {{ billingResponse().discountInPercentSiaCorporate | number: "1.0-0"
                              }}{{ t("prices.discount.sia-company") }}
                            </td>
                            <td class="text-align">- {{ billingResponse().yearlySiaDiscount / 100 }} CHF</td>
                          </tr>
                        </ng-container>
                      }
                      <tr>
                        <td class="text-align">{{ t("billing.table.pricing.price-no-vat") }}</td>
                        <td class="text-align">
                          {{ billingResponse().yearlyTotalExclVAT / 100 | number: "1.2-2" }} CHF
                        </td>
                      </tr>
                      <tr class="solidBottomBorder">
                        <td class="text-align">
                          {{ billingResponse().vat | number: "1.2-2" }}<span>{{ t("prices.mwst") }}</span>
                        </td>
                        <td class="text-align">
                          {{ billingResponse().yearlyEffectiveVAT / 100 | number: "1.2-2" }} CHF
                        </td>
                      </tr>
                      <tr class="solidBottomBorder">
                        <td class="text-align">
                          <b>{{ t("prices.licence.total-yearly-vat") }}</b>
                        </td>
                        <td class="text-align">
                          <b>{{ billingResponse().yearlyTotalInclVAT / 100 | number: "1.2-2" }} CHF</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              @if (registerComplete()) {
                <div class="centeredBoxText" smooth-scroll data-duration="250" data-offset="0">
                  <h3>{{ t("register.form.license.end-1") }}</h3>
                </div>
                <div class="flexBoxOuter">
                  <div
                    class="alert kw-attention centeredBoxText flexBoxInner"
                    [innerHtml]="t('register.messages.success')"
                  ></div>
                </div>
              } @else {
                <div class="centeredBoxText mt-3 mb-3">
                  <button mat-button color="primary" class="btn btn-elegant-black mb-3" (click)="register()">
                    {{ t("register.form.finish") }}
                  </button>
                </div>
              }
              <div class="flexBoxOuter">
                <div class="centeredBoxText flexBoxInner mb-3">
                  <p class="alert kv-attention" [innerHtml]="t('register.form.abo-convert.text-1')"></p>
                </div>
              </div>
              <div class="centeredBoxText mb-3">
                <div style="margin-bottom: 15px">
                  <span>{{ t("register.form.abo-convert.text-2") }}</span>
                  <a href="mailto:{{ t('products.about.text-2-2') }}">{{ t("products.about.text-2-2") }}</a>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (hasStartFreeMonth() && checkSuccess() && numEmp() > maxEmployeesForSelfService) {
    <div class="mb-20">
      <div class="flexBoxOuter pb-20">
        <div class="flexBoxInner txt" style="width: 450px">
          <div smooth-scroll data-duration="250" data-offset="66">
            <h4>{{ t("register.form.to-big.title") }}</h4>
            {{ t("register.form.to-big.text") }}
          </div>
          <div class="kv-inner-wrapper">
            <div class="cLabel md-block">
              <mat-form-field [floatLabel]="'always'" class="example-full-width" appearance="outline">
                <textarea
                  #txtarea
                  matInput
                  cdkTextareaAutosize
                  placeholder="{{ t('register.form.to-big.contact') }}"
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1"
                  [ngModel]="message()"
                  (ngModelChange)="message.set($event)"
                  [maxLength]="300"
                  cdkAutosizeMaxRows="6"
                >
                </textarea>
                <mat-hint align="end">{{ txtarea.value.length || 0 }}/300</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="centeredBoxText" style="margin-top: 20px">
            @if (!contactSuccess()) {
              <button
                mat-button
                type="button"
                color="primary"
                class="btn btn-elegant-orange"
                style="padding-top: 0"
                (click)="sendContact()"
              >
                {{ t("global.request.send.title") }}
              </button>
            } @else {
              <p class="alert kv-attention">
                {{ t("global.request.send.success") }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
